// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Card, CardContent } from "@mui/material";
import DocsNav from "./components/funding-nav";
import FixDocs from "./components/funding-doc";
import "../docs.css";
import { useRef, useState } from "react";

function Funding() {
  const [search, setSearch] = useState("");
  const getData = (data) => {
    setSearch(data);
  };
  const scrollRef = useRef(null);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} px={2} pb={2}>
        <Card
          style={{ maxHeight: 800, overflowY: "auto" }}
          className="onscroll"
          ref={scrollRef}
        >
          <CardContent>
            <Grid container spacing={2} py={2}>
              <Grid item md={2.5} xs={12}>
                <Card className="sticky-nav">
                  <CardContent>
                    <DocsNav
                      searchedData={getData}
                      titleNode={
                        <div className="pdl-nav-title">
                          <span className="pdl-nav-title__name">Funding API</span>
                          <span className="pdl-nav-title__version">v1.0</span>
                        </div>
                      }
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={9.5} xs={12} className="scroll-inside">
                <Grid container spacing={0} py={0}>
                  <FixDocs scrollRef={scrollRef} search={search} />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Funding;
